/**
 * Whether the applicant must explain or revise employment gaps (not merely
 * wait for Osabea review). Mirrors backend employment_gaps_need_worker_action.
 */

export function employmentGapsNeedWorkerAction(gapEvaluation) {
  if (!gapEvaluation) return false;
  const pending = Number(gapEvaluation.pending_count) || 0;
  const rejected = Number(gapEvaluation.rejected_count) || 0;
  const needsInfo = Number(gapEvaluation.needs_info_count) || 0;
  return pending + rejected + needsInfo > 0;
}

function isEmploymentGapBlocker(blocker) {
  const type = String(blocker?.type || '').toLowerCase();
  return type === 'employment_gaps' || type.includes('employment_gap');
}

function employmentGapBlockerNeedsWorker(blocker) {
  if (!isEmploymentGapBlocker(blocker)) return false;
  if (String(blocker?.classification || '').toLowerCase() === 'worker_action') return true;
  if (String(blocker?.actor || '').toLowerCase() === 'worker') return true;
  const label = String(blocker?.label || '').toLowerCase();
  return (
    label.includes('require explanation')
    || label.includes('rejected')
    || label.includes('more information')
    || label.includes('revision needed')
  );
}

export function deriveEmploymentGapsNeedAction({
  gapEvaluation = null,
  employmentReadinessBlockers = [],
  pendingWorkerActions = [],
} = {}) {
  if (gapEvaluation) {
    if (employmentGapsNeedWorkerAction(gapEvaluation)) return true;
    return (employmentReadinessBlockers || []).some(employmentGapBlockerNeedsWorker);
  }
  if ((pendingWorkerActions || []).some((action) => action?.key === 'employment_gaps')) return true;
  return (employmentReadinessBlockers || []).some(employmentGapBlockerNeedsWorker);
}
